import { h } from 'preact';

const PauseButton = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
			<path d="M4.155 0a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-4Zm12 0a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-4Z" />
		</svg>
	);
};

export default PauseButton;
